import Vue from "vue";
import search from "../../vue/search/search.vue";
import SearchPageLinkPlugin from "./plugins/searchPageLink";
import QueryParamsPlugin from "./plugins/queryParams";

Vue.use(SearchPageLinkPlugin);
Vue.use(QueryParamsPlugin);

export default function(el) {
    new Vue({
        el,
        components: {
            search,
        },
    });
}
